import * as api from '../api';

export const coachAddUserToTeam = async (orgId, userId, teamId) =>
    await api.get(`/2.0/coach/admin/group/add/${orgId}/${userId}/${teamId}`);

export const coachChangeUnits = async (orgId, userId) =>
    await api.get(`/2.0/coach/admin/toggleMetric/${orgId}/${userId}`);

export const coachRemoveUserFromTeam = async (orgId, userId, teamId) =>
    await api.get(`/2.0/coach/admin/group/remove/${orgId}/${userId}/${teamId}`);

export const coachResetPassword = async userId =>
    await api.post(`/v5/users/${userId}/sendResetPasswordEmailForUser`);

export const create = async () => await api.post('/1.0/coach/team/create');

export const createWithCalSubscription = async (teamId, info) =>
    await api.post(`/1.0/coach/team/createWithCS/${teamId}`, info);

export const createWithTitleAndCode = async team =>
    await api.post('/1.0/coach/team/createWithTitleAndCode', team);

export const deleteSubscription = async (teamId, subscribedTeamId) =>
    await api.del(`/3.0/coach/team/${teamId}/subscription/${subscribedTeamId}`);

export const getAll = async (page, pageSize) => {
    let queryString = '';
    if (page) queryString = `?page=${page}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;

    return await api.get(`/1.0/coach/teams${queryString}`);
};

export const getAllSubscribedTeams = async teamId =>
    await api.get(`/1.0/coach/team/allLicenseSubscribedTeams/${teamId}`);

export const getTeamAthletesById = async teamId =>
    await api.get(`/1.0/coach/team/allAthletes/${teamId}`);

export const search = async (q, page, pageSize) => {
    let queryString = '';
    if (page) queryString = `?page=${page}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;
    if (q) queryString += `&q=${q}`;
    return await api.get(`/1.0/coach/teams${queryString}`);
};

export const subscribeToTeam = async (
    parentTeamId,
    childTeamId,
    year,
    month,
    dayPadding,
    communityEnabled
) =>
    // eslint-disable-next-line
    await api.post(`/1.0/coach/team/subscribeToTeam/${parentTeamId}/${childTeamId}/${year}/${month}/${dayPadding}/${communityEnabled}`,null);

export const updatePublishSettings = async team =>
    await api.post('/1.0/coach/team/updatePublishSettings', team);



// WEBPACK FOOTER //
// ./src/api/service/teamService.js